import { PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";
import { isFilled } from "@prismicio/client";
import { Button } from "@/components";
import Styles from "./ServiceLanding.module.css";

/**
 * @typedef {import("@prismicio/client").Content.HeroSlice} HeroSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<HeroSlice>} HeroProps
 * @param { HeroProps }
 */

const ServiceLanding = ({ primary }) => {
	/*
		Prismic Select fields hand back the display string ("Lines"), and an unset
		Select is undefined — the CSS selectors are lowercase, so normalise here the
		same way Utility/useColorPicker.js maps a Select value onto a CSS token.
	*/
	const texture = (primary?.texture || "none").toLowerCase();
	const hasImage = isFilled.image(primary?.image);
	const dark = primary?.dark_theme;

	const hasPrimaryCta = primary?.primary_cta_label && primary?.primary_cta_link;
	const hasSecondaryCta =
		primary?.secondary_cta_label && primary?.secondary_cta_link;

	return (
		<section
			className={Styles.wrapper}
			data-theme={dark ? "dark" : "light"}
			data-texture={texture}
			data-has-image={hasImage}>
			<div className={Styles.backdrop} aria-hidden="true"></div>
			<div className={Styles.container} data-contain="true">
				<div className={Styles.content}>
					{primary?.eyebrow && (
						<p className={Styles.eyebrow}>
							<span className={Styles.eyebrowRule} aria-hidden="true"></span>
							{primary?.eyebrow}
						</p>
					)}
					<div className={Styles.heading}>
						<PrismicRichText field={primary?.heading} />
					</div>
					<div className={Styles.description}>
						<PrismicRichText field={primary?.description} />
					</div>
					{(hasPrimaryCta || hasSecondaryCta) && (
						<div className={Styles.btnContainer}>
							{hasPrimaryCta && (
								<Button
									link={primary?.primary_cta_link}
									label={primary?.primary_cta_label}
								/>
							)}
							{hasSecondaryCta && (
								<Button
									link={primary?.secondary_cta_link}
									label={primary?.secondary_cta_label}
									variant="secondary"
									lightTheme={dark}
								/>
							)}
						</div>
					)}
				</div>

				{hasImage && (
					<div className={Styles.media}>
						<PrismicNextImage
							field={primary?.image}
							fill
							className={Styles.img}
							sizes="(max-width: 768px) 100vw, 40vw"
							style={{ objectFit: "cover", objectPosition: "center" }}
						/>
					</div>
				)}
			</div>
			<div className={Styles.rule} aria-hidden="true"></div>
		</section>
	);
};

export default ServiceLanding;
